import "../styles/globals.css";

import Head from "next/head";
import {useRouter} from "next/router";
import Script from "next/script";
import {useEffect} from "react";
import {fPageview} from "utils/fpixel";
import {sPageview} from "utils/spixel";

function MyApp({Component, pageProps}) {
  const router = useRouter();

  useEffect(() => {
    // This pageview only triggers the first time (it's important for Pixel to have real information)
    fPageview();
    sPageview();

    const handleRouteChange = () => {
      fPageview();
      sPageview();
    };

    router.events.on("routeChangeComplete", handleRouteChange);
    return () => {
      router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, [router.events]);
  return (
    <>
      <Head>
        <link rel="icon" href="/raha.ico" />
        <link
          rel="preload"
          href="/fonts/GraphikArabic-Bd.ttf"
          as="font"
          crossOrigin=""
        />
        <link
          rel="preload"
          href="/fonts/GraphikArabic-Md.ttf"
          as="font"
          crossOrigin=""
        />
        <link
          rel="preload"
          href="/fonts/GraphikArabic-Rg.ttf"
          as="font"
          crossOrigin=""
        />
      </Head>
      {process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_ID && (
        <Script
          dangerouslySetInnerHTML={{
            __html: `
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', ${process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_ID});
          `,
          }}
        />
      )}
      {process.env.NEXT_PUBLIC_SNAPCHAT_PIXEL_ID && (
        <Script
          dangerouslySetInnerHTML={{
            __html: `
          (function(e,t,n){if(e.snaptr)return;var a=e.snaptr=function()
            {a.handleRequest?a.handleRequest.apply(a,arguments):a.queue.push(arguments)};
            a.queue=[];var s='script';r=t.createElement(s);r.async=!0;
            r.src=n;var u=t.getElementsByTagName(s)[0];
            u.parentNode.insertBefore(r,u);})(window,document,
            'https://sc-static.net/scevent.min.js');
            snaptr('init', '${process.env.NEXT_PUBLIC_SNAPCHAT_PIXEL_ID}', {
            'user_email': '__INSERT_USER_EMAIL__'
            });
          `,
          }}
        />
      )}
      {process.env.NEXT_PUBLIC_LINKEDIN_PARTNER_ID && (
        <Script
          dangerouslySetInnerHTML={{
            __html: `_linkedin_partner_id = ${process.env.NEXT_PUBLIC_LINKEDIN_PARTNER_ID}; window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || []; window._linkedin_data_partner_ids.push(_linkedin_partner_id);`,
          }}
        />
      )}
      <Script
        dangerouslySetInnerHTML={{
          __html: `(function(l) { if (!l){window.lintrk = function(a,b){window.lintrk.q.push([a,b])}; window.lintrk.q=[]} var s = document.getElementsByTagName("script")[0]; var b = document.createElement("script"); b.type = "text/javascript";b.async = true; b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js"; s.parentNode.insertBefore(b, s);})(window.lintrk);`,
        }}
      />
      {process.env.NEXT_PUBLIC_GOOGLE_ADSENSE_ID && (
        <Script
          async
          crossorigin="anonymous"
          src={`https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${process.env.NEXT_PUBLIC_GOOGLE_ADSENSE_ID}`}
        />
      )}
      {process.env.NEXT_PUBLIC_TIKTOK_PIXEL_ID && (
        <Script
          dangerouslySetInnerHTML={{
            __html: `
            (!function (w, d, t) {
              w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];
              ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"],
              ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};
              for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);
              ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++
              )ttq.setAndDefer(e,ttq.methods[n]);
              return e},ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";
              ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};
              n=document.createElement("script");n.type="text/javascript",n.async=!0,n.src=i+"?sdkid="+e+"&lib="+t;
              e=document.getElementsByTagName("script")[0];e.parentNode.insertBefore(n,e)};
              ttq.load('${process.env.NEXT_PUBLIC_TIKTOK_PIXEL_ID}');
		          ttq.page();
		        }(window, document, 'ttq'));
            `,
          }}
        />
      )}
      <main>
        <Component {...pageProps} />
      </main>
    </>
  );
}

export default MyApp;
